<section id="content" *ngIf="lang">

  <div class="page page-profile">

    <div class="pageheader">

      <h2>{{modalTitle}}</h2>

    </div>

    <!-- page content -->
    <div class="pagecontent">


      <!-- row -->
      <div class="row">

        <div class="col-md-12">

          <!-- tile -->
          <section class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body p-0">

              <div role="tabpanel">


                <!-- Tab panes -->
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">

                    <div class="wrap-reset">

                      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                        <div *ngFor="let validation of msg">
                          <div class="error-message"
                            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                            {{validation.message}}
                          </div>
                        </div>
                      </ng-template>

                      <form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">

                        <div class="row">

                          <div class="form-group col-sm-12">
                            <label for="first-name">{{ lang.description }}</label>
                            <textarea class="form-control" formControlName="measurement_discrp"
                              [ngClass]="formErrorClass(createForm.controls.measurement_discrp, createFormSubmitted)"></textarea>

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.measurement_discrp, value:createForm.controls.measurement_discrp, submitted:createFormSubmitted }">
                            </ng-template>
                          </div>


                          <div class="col-sm-12" formArrayName="photo">
                            <label>{{ lang.photo }}</label>
                            <div class="form-group row" *ngFor="let link of photo().controls; let i = index;"
                              [formGroupName]="i">
                              <div class="col-sm-12">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment2($event,i)" formControlName="link" appFileDesign>
                              </div>


                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                                [ngTemplateOutletContext]="{msg:createFormErrorMsg.photo, value:photo().controls[i].controls['link'], submitted:createFormSubmitted }">
                              </ng-template>

                            </div>
                            <!-- <div class="form-group col-sm-6" formArrayName="photo_img">

                              <div class="form-group row" *ngFor="let image of photo_img().controls; let i=index">
                                <div class="col-sm-11">
                                  <input type="hidden" class="form-control" formControlName="{{i}}">
                                  <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                    (change)="selectAttachment2($event,i)" value="{{image.value.split('/').pop()}}">

                                  <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/measurment_tools/{{image.value.split('/').pop()}}"
                                    target="_blank">{{image.value.split('/').pop()}}</a>

                                </div>
                                <div class="col-sm-1">
                                  <button class="btn btn-primary pull-right" type="button"
                                    (click)="removeAttachmentUploaded2(i)">
                                    <i class="fa fa-trash-o"></i>
                                  </button>
                                </div>
                              </div>
                            </div> -->


                            <div class="col-sm-12" formArrayName="measurement_image_uploaded">
                              <div class="form-group col-sm-12">

                                <div class="form-group row"
                                  *ngFor="let image of measurement_image_uploaded().controls; let i=index">
                                  <div class="col-sm-11">
                                    <input type="hidden" class="form-control" formControlName="{{i}}">
                                    <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                      (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                    <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
                                    <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/measurment_tools/{{image.value.split('/').pop()}}"
                                      target="_blank">{{image.value.split('/').pop()}}</a>

                                  </div>
                                  <div class="col-sm-1">
                                    <button class="btn btn-primary pull-right" type="button"
                                      (click)="removeAttachmentUploaded2(i)">
                                      <i class="fa fa-trash-o"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </div>



                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.brand }}</label>
                            <input type="text" class="form-control" formControlName="measurement_brand"
                              [ngClass]="formErrorClass(createForm.controls.measurement_brand, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.measurement_brand, value:createForm.controls.measurement_brand, submitted:createFormSubmitted }">
                            </ng-template>

                          </div>



                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.model }}</label>
                            <input type="text" class="form-control" formControlName="measurement_model"
                              [ngClass]="formErrorClass(createForm.controls.measurement_model, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.measurement_model, value:createForm.controls.measurement_model, submitted:createFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.dateofPurchase }}</label>
                            <input type="date" class="form-control" formControlName="measurement_doc"
                              [ngClass]="formErrorClass(createForm.controls.measurement_doc, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.measurement_doc, value:createForm.controls.measurement_doc, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.internalCode }}</label>
                            <input type="text" class="form-control" formControlName="internal_code"
                              [ngClass]="formErrorClass(createForm.controls.internal_code, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.internal_code, value:createForm.controls.internal_code, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.serialNumber }}</label>
                            <input type="text" class="form-control" formControlName="badge_no"
                              [ngClass]="formErrorClass(createForm.controls.badge_no, createFormSubmitted)">


                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.badge_no, value:createForm.controls.badge_no, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>



                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.location }}</label>
                            <input type="text" class="form-control" formControlName="measurement_location"
                              [ngClass]="formErrorClass(createForm.controls.measurement_location, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.measurement_location, value:createForm.controls.measurement_location, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>

                          <div class="col-sm-12" formArrayName="fileupload">
                            <label>{{ lang.documentAttachment }}</label>
                            <div class="form-group row" *ngFor="let link of fileupload().controls; let i = index;"
                              [formGroupName]="i">
                              <div class="col-sm-12">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" formControlName="link" appFileDesign>
                              </div>


                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                                [ngTemplateOutletContext]="{msg:createFormErrorMsg.fileupload, value:fileupload().controls[i].controls['link'], submitted:createFormSubmitted }">
                              </ng-template>

                            </div>
                            <div class="form-group col-sm-6" formArrayName="service_image_uploaded">

                              <div class="form-group row"
                                *ngFor="let image of service_image_uploaded().controls; let i=index">
                                <div class="col-sm-11">
                                  <input type="hidden" class="form-control" formControlName="{{i}}">
                                  <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                    (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                  <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/measurment_tools/{{image.value.split('/').pop()}}"
                                    target="_blank">{{image.value.split('/').pop()}}</a>

                                </div>
                                <div class="col-sm-1">
                                  <button class="btn btn-primary pull-right" type="button"
                                    (click)="removeAttachmentUploaded1(i)">
                                    <i class="fa fa-trash-o"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.measuringRange }}</label>
                            <input type="text" class="form-control" formControlName="measuring_range"
                              [ngClass]="formErrorClass(createForm.controls.measuring_range, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.measuring_range, value:createForm.controls.measuring_range, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.resolution }}</label>
                            <input type="text" class="form-control" formControlName="precision_degree"
                              [ngClass]="formErrorClass(createForm.controls.precision_degree, createFormSubmitted)">


                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.precision_degree, value:createForm.controls.precision_degree, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.maxallowedError }}</label>
                            <input type="text" class="form-control" formControlName="measurement_uncertainty"
                              [ngClass]="formErrorClass(createForm.controls.measurement_uncertainty, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.measurement_uncertainty, value:createForm.controls.measurement_uncertainty, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>

                          <div class="form-group col-sm-6">
                            <label>Applicable Calibration Plans</label>

                            <ng-multiselect-dropdown formControlName="calibration_plans" [data]="calibration_data"
                              [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.calibration_plans, value:createForm.controls.calibration_plans, submitted:createFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label>{{ lang.responsible }}</label>
                            <select class="form-control" formControlName="emp_id"
                              [ngClass]="formErrorClass (createForm.controls.emp_id, createFormSubmitted)">
                              <option value="">Select Employee</option>
                              <option *ngFor="let resp of app_emp_id" [ngValue]="resp.item_id">{{resp.item_name}}
                              </option>
                            </select>


                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.emp_id, value:createForm.controls.emp_id, submitted:createFormSubmitted }">
                            </ng-template>

                          </div>


                          <div class="form-group col-sm-6">
                            <label>{{ lang.typeofCalibration }}</label>
                            <select class="form-control" formControlName="calibration_type"
                              [ngClass]="formErrorClass (createForm.controls.calibration_type, createFormSubmitted)">
                              <option value="">Select Type</option>
                              <option *ngFor="let resp of courseType" [ngValue]="resp.item_id">{{resp.item_name}}
                              </option>
                            </select>


                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.calibration_type, value:createForm.controls.calibration_type, submitted:createFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-12">
                            <label>State</label>
                            <div>
                              <label class="checkbox-inline checkbox-custom-alt">
                                <input type="radio" formControlName="state" value="Active"
                                  [ngClass]="formErrorClass (createForm.controls.state, createFormSubmitted)"><i></i>Active
                              </label>
                              <label class="checkbox-inline checkbox-custom-alt">
                                <input type="radio" formControlName="state" value="Decommissioned"
                                  [ngClass]="formErrorClass (createForm.controls.state, createFormSubmitted)"><i></i>Decommissioned
                              </label>
                            </div>
                          </div>


                          <div class="form-group col-sm-2">
                            <button type="submit" class="btn btn-primary">Save</button>
                          </div>

                        </div>


                      </form>

                    </div>

                  </div>



                </div>

              </div>

            </div>
            <!-- /tile body -->

          </section>
          <!-- /tile -->

        </div>


      </div>
      <!-- /page content -->

    </div>
  </div>

</section>